<template>
   <b-modal
      id="upload-document-modal"
      title="Upload Documents"
      size="xl"
      @hidden="hide"
      body-class="modal-body-custom"
      no-close-on-backdrop
      no-close-on-esc
   >
      <div class="upload-document-modal-container">
         <FileUploadSelectPeriodComponent
            ref="pendingUpload"
            :currentFiles="currentFiles"
            :uploadCategoryId="uploadCategoryId"
            limits="Limit 100MB"
            :multiple="true"
         />
      </div>
      <template #modal-footer>
         <div class="modal-footer-custom">
            <b-button
               v-if="$refs.pendingUpload && $refs.pendingUpload.files.some((f) => !f.existing)"
               class="finish-button dark-button"
               variant="primary"
               :disabled="fileUploadBusy"
               @click="finish"
            >
               Upload
            </b-button>
         </div>
      </template>
   </b-modal>
</template>

<script>
import FileUploadSelectPeriodComponent from '@/components/FileUploadSelectPeriodComponent.vue';

export default {
   name: 'UploadDocumentModal',

   components: {FileUploadSelectPeriodComponent},

   data() {
      return {
         currentFiles: [],
         category: null,
         fileUploadBusy: false,
      };
   },
   computed: {
      uploadCategoryId() {
         return this.category ? this.category.id : null;
      },
   },

   methods: {
      show(category) {
         this.category = category;
         this.currentFiles = category.summary;
         this.fileUploadBusy = false;
         this.$bvModal.show('upload-document-modal');
         this.$nextTick(() => {
            this.$refs.pendingUpload?.clearFiles();
         });
      },

      hide() {
         this.$bvModal.hide('upload-document-modal');
      },

      async finish() {
         if (!this.$refs.pendingUpload) {
            this.hide();
            return;
         }

         this.fileUploadBusy = true;
         try {
            await this.$refs.pendingUpload.finish();
            this.currentFiles = [...this.$refs.pendingUpload.files];
            this.hide();
         } finally {
            this.fileUploadBusy = false;
         }
      },
   },
};
</script>

<style scoped lang="scss">
.upload-document-modal-container {
   display: flex;
   flex-direction: column;
}
::v-deep .modal-dialog,
::v-deep .modal-content {
   height: stretch;
}
::v-deep .modal-body-custom {
   padding: 1.5rem;
   min-height: 50vh;
   overflow: hidden;
   display: flex;
   flex-direction: column;
}

::v-deep .file-preview-container {
   max-height: calc(100vh - 30rem);
   overflow-y: auto;
}

::v-deep .file-preview-container::-webkit-scrollbar {
   width: 8px; /* always visible width */
}
::v-deep .file-preview-container::-webkit-scrollbar-track {
   background: #eee; /* visible track */
}

::v-deep .file-preview-container::-webkit-scrollbar-thumb {
   background: #999; /* visible thumb */
   border-radius: 6px;
}
.modal-footer-custom {
   display: flex;
   justify-content: flex-end;
   gap: 0.75rem;
   padding-top: 1.25rem;
}
</style>
